import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-documents-zip-icon',
  templateUrl: './documents-zip.component.html'
})
export class DocumentsZipComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
